var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPodcastLocked = function SvgPodcastLocked(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3313_14664)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3313_14664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0.0615234H0V40.7695H40V0.0615234Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3313_14664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2185 1.78578L3.97951 2.33255C1.78168 2.37102 0.0311033 4.18875 0.0694663 6.39257L0.597379 36.7193C0.635743 38.9231 2.44852 40.6785 4.64633 40.64L35.8854 40.0933C38.0832 40.0549 39.8338 38.237 39.7954 36.0332L39.2675 5.7065C39.2291 3.50268 37.4163 1.74731 35.2185 1.78578Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0822 4.21122L6.42466 4.6953C5.43564 4.71262 4.64788 5.53059 4.66513 6.52231L5.15485 34.6544C5.17212 35.6461 5.98786 36.4361 6.97688 36.4188L34.6344 35.9347C35.6233 35.9173 36.4112 35.0994 36.3939 34.1076L35.9041 5.97555C35.887 4.98383 35.0711 4.19392 34.0822 4.21122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3313_14664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4997 0.0615234H13.3653C11.9915 0.0615234 10.8777 1.17829 10.8777 2.55588C10.8777 3.93349 11.9915 5.05024 13.3653 5.05024H26.4997C27.8734 5.05024 28.9873 3.93349 28.9873 2.55588C28.9873 1.17829 27.8734 0.0615234 26.4997 0.0615234Z",
    fill: "#B1B1B1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.0944 32.3879C27.1394 32.3879 32.0397 27.4741 32.0397 21.4127C32.0397 15.3513 27.1394 10.4375 21.0944 10.4375C15.0495 10.4375 10.1492 15.3513 10.1492 21.4127C10.1492 27.4741 15.0495 32.3879 21.0944 32.3879Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9005 31.3908C25.9454 31.3908 30.8458 26.477 30.8458 20.4156C30.8458 14.3542 25.9454 9.44043 19.9005 9.44043C13.8556 9.44043 8.95522 14.3542 8.95522 20.4156C8.95522 26.477 13.8556 31.3908 19.9005 31.3908Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2051 26.4872C15.8727 26.4872 15.5887 26.3695 15.3532 26.134C15.1178 25.8986 15 25.6146 15 25.2821V19.0257C15 18.6933 15.1178 18.4093 15.3532 18.1738C15.5887 17.9383 15.8727 17.8206 16.2051 17.8206H17V16.4873C17 15.6548 17.2919 14.9467 17.8756 14.3629C18.4594 13.7792 19.1675 13.4873 20 13.4873C20.8325 13.4873 21.5406 13.7792 22.1243 14.3629C22.7081 14.9467 23 15.6548 23 16.4873V17.8206H23.7948C24.1273 17.8206 24.4113 17.9383 24.6468 18.1738C24.8822 18.4093 25 18.6933 25 19.0257V25.2821C25 25.6146 24.8822 25.8986 24.6468 26.134C24.4113 26.3695 24.1273 26.4872 23.7948 26.4872H16.2051ZM16.2051 25.4873H23.7948C23.8547 25.4873 23.9038 25.468 23.9423 25.4296C23.9808 25.3911 24 25.3419 24 25.2821V19.0257C24 18.9659 23.9808 18.9168 23.9423 18.8783C23.9038 18.8398 23.8547 18.8206 23.7948 18.8206H16.2051C16.1453 18.8206 16.0962 18.8398 16.0577 18.8783C16.0192 18.9168 16 18.9659 16 19.0257V25.2821C16 25.3419 16.0192 25.3911 16.0577 25.4296C16.0962 25.468 16.1453 25.4873 16.2051 25.4873ZM20 23.3206C20.3239 23.3206 20.5994 23.2071 20.8263 22.9802C21.0532 22.7533 21.1666 22.4779 21.1666 22.1539C21.1666 21.83 21.0532 21.5546 20.8263 21.3277C20.5994 21.1007 20.3239 20.9873 20 20.9873C19.6761 20.9873 19.4006 21.1007 19.1737 21.3277C18.9468 21.5546 18.8333 21.83 18.8333 22.1539C18.8333 22.4779 18.9468 22.7533 19.1737 22.9802C19.4006 23.2071 19.6761 23.3206 20 23.3206ZM18 17.8206H22V16.4873C22 15.9317 21.8056 15.4595 21.4167 15.0706C21.0278 14.6817 20.5556 14.4873 20 14.4873C19.4444 14.4873 18.9722 14.6817 18.5833 15.0706C18.1944 15.4595 18 15.9317 18 16.4873V17.8206Z",
    fill: "#4A4A48"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3313_14664",
    x: 10.8777,
    y: 0.0615234,
    width: 18.8175,
    height: 6.40421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.707965,
    dy: 1.41593
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454199 0 0 0 0 0.435399 0 0 0 0 0.259915 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3313_14664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3313_14664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3313_14664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40.708,
    fill: "white",
    transform: "translate(0 0.0625)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPodcastLocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "podcast_locked.0acff7ce04fa2f362ad7efd88b4b4f24.svg";